import isContractInitialized from './ContractInitializationState';
import { ADD_COINS_MINTED_EVENT } from '../storage/CoinsMintedEventReducer';
import { UPDATE_ADDRESS_FREEZING_STATUS } from '../storage/FrozenAddressesReducer';
import Storage from '../storage/Storage';
import { ADD_TRANSACTION_EVENT } from '../storage/TransactionEventReducer';
import { ADD_COINS_BOUGHT_EVENT } from '../storage/CoinsBoughtEventReducer';
import { UPDATE_CAN_ADDRESS_BUY_COINS } from '../storage/AddressCanBuyCoinsReducer';

export default class EventsUpdaterService {
  constructor () {
    this.contractLoaded = false;
    this.storageUnsubscribe = null;
  }

  init () {
    this.isContractLoaded();
    this.storageUnsubscribe = Storage.subscribe(
      () => this.isContractLoaded());
  }

  isContractLoaded () {
    return isContractInitialized() && !this.contractLoaded && this.initEventUpdater();
  }

  initEventUpdater () {
    this.contractLoaded = true;
    this.storageUnsubscribe && this.storageUnsubscribe();

    this.fetchTransfers();
    this.fetchCoinsMinted();
    this.fetchAddressRefrigerator();
    this.fetchCoinsBought();
    this.fetchAddressNameChange();
    this.fetchAddressBuyingOfCoinsRefrigerator();
  }

  fetchTransfers () {
    window.oldWeb3Contract
      .Transfer({}, {fromBlock: 0, toBlock: 'latest'})
      .watch((err, TransferEvent) => {
        if (err) {
          return;
        }

        Storage.dispatch({type: ADD_TRANSACTION_EVENT, payload: TransferEvent});
      });
  }

  fetchCoinsMinted () {
    window.oldWeb3Contract
      .TokensMinted({}, {fromBlock: 0, toBlock: 'latest'})
      .watch((err, CoinMintedEvent) => {
        if (err) {
          return;
        }

        Storage.dispatch({type: ADD_COINS_MINTED_EVENT, payload: CoinMintedEvent});
      });
  }

  fetchCoinsBought () {
    window.oldWeb3Contract
      .TokensBought({}, {fromBlock: 0, toBlock: 'latest'})
      .watch((err, CoinBoughtEvent) => {
        if (err) {
          return;
        }

        Storage.dispatch({type: ADD_COINS_BOUGHT_EVENT, payload: CoinBoughtEvent});
      });
  }

  fetchAddressRefrigerator () {
    window.oldWeb3Contract
      .AddressFreezeChange({}, {fromBlock: 0, toBlock: 'latest'})
      .watch((err, AddressFreezeChangeEvent) => {
        if (err) {
          return;
        }

        Storage.dispatch({
          type: UPDATE_ADDRESS_FREEZING_STATUS,
          payload: {address: AddressFreezeChangeEvent.args.to, state: AddressFreezeChangeEvent.args.state}
        });
      });
  }

  fetchAddressNameChange () {
    window.oldWeb3Contract
      .AddressNameChange({}, {fromBlock: 0, toBlock: 'latest'})
      .watch((err, AddressNameChangeEvent) => {
        if (err) {
          return;
        }

        window.addressToNameService.setNameForAddress(
          AddressNameChangeEvent.args.to,
          AddressNameChangeEvent.args.name
        );
      });
  }

  fetchAddressBuyingOfCoinsRefrigerator () {
    window.oldWeb3Contract
      .AddressCanBuyTokensStatusChange({}, {fromBlock: 0, toBlock: 'latest'})
      .watch((err, AddressCanBuyCoinsStatusChange) => {
        if (err) {
          return;
        }

        Storage.dispatch({
          type: UPDATE_CAN_ADDRESS_BUY_COINS,
          payload: {address: AddressCanBuyCoinsStatusChange.args.to, state: AddressCanBuyCoinsStatusChange.args.state}
        });
      });
  }
}



// WEBPACK FOOTER //
// ./src/utils/EventsUpdaterService.js